module.exports = __webpack_public_path__ + "img/00—01—Login—IB2 > Input Alert Message.6feb7736.jpg";